import { tool } from 'ai';
import { z } from 'zod';

export function createMathTools() {
  return {
    math_divide: tool({
      description: 'Divides two numbers',
      parameters: z.object({
        dividend: z.number(),
        divisor: z.number().nonnegative(),
      }),
      execute: ({ dividend, divisor }) => {
        if (divisor === 0) {
          return Promise.resolve({ success: false, result: 0, message: 'Division by zero is not allowed' });
        }
        return Promise.resolve({ success: true, result: dividend / divisor });
      },
    }),
    math_multiply: tool({
      description: 'Multiplies two numbers',
      parameters: z.object({
        multiplicand: z.number(),
        multiplier: z.number(),
      }),
      execute: ({ multiplicand, multiplier }) => {
        return Promise.resolve({ success: true, result: multiplicand * multiplier });
      },
    }),
  };
}
